var map = {
	"./abroad.svg": "0883",
	"./appraisal.svg": "b02e",
	"./archives.svg": "ae47",
	"./artifacts-transfer.svg": "2ca6",
	"./auction.svg": "6efb",
	"./building.svg": "8c51",
	"./changan-street.svg": "6502",
	"./china.svg": "373b",
	"./entry-exit.svg": "c658",
	"./entry-exit2.svg": "d382",
	"./famous-town.svg": "ffeb",
	"./great-wall.svg": "6811",
	"./group.svg": "a75f",
	"./guohui.svg": "35af",
	"./home.svg": "6bbe",
	"./inspector.svg": "1ab2",
	"./party-flag.svg": "d59f",
	"./person-card.svg": "7f51",
	"./qualification.svg": "c18e",
	"./search-person.svg": "2ef7",
	"./shanghai-customs.svg": "ed7a",
	"./shanghai-flag.svg": "1ceb",
	"./shanghai.svg": "1a5a",
	"./shop.svg": "5def",
	"./shovel.svg": "8b05",
	"./site.svg": "c99e",
	"./special-person.svg": "874f",
	"./street.svg": "542c",
	"./sunbird.svg": "5e0c",
	"./survey-design.svg": "a67d",
	"./survey-person.svg": "1370",
	"./tourism.svg": "4cca",
	"./tourist-guide.svg": "5aa7",
	"./village.svg": "26e3",
	"./zizhi.svg": "f28d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";